// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__173SU","left":"StickyBox_left__Z14rl","right":"StickyBox_right__JNlje"};